module.exports = __webpack_public_path__ + "img/42.e00e963b.png";